import { Status, Wrapper } from "@googlemaps/react-wrapper";

type TProps = {
  children: React.ReactNode;
};

const render = (status: Status) => {
  return <h1>{status}</h1>;
};
const apiKey = 'AIzaSyAR_uQnLNy7GzL3E7GwZ-g-hC8AHl1JTYE'; 

const MapWrapper = ({ children }: TProps) => {
  return (
    <Wrapper
      //apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}
      apiKey={apiKey || ""}
      render={render}
      libraries={['geometry']}
    >
      {children}
    </Wrapper>
  );
};

export default MapWrapper;
